import React, { useState } from "react";
import { get } from "lodash";
import { Link, useHistory } from "react-router-dom";
import { FormGroup } from "reactstrap";
import { LocalForm, Control } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import SaveButton from "components/common/Forms/SaveButton";
import { Trans, useTranslation } from "react-i18next";
import { useClient, useUserContext } from "../../hooks";

export const Login = () => {
  const history = useHistory();
  const client = useClient();
  const { query } = useUserContext();
  const [item, setItem] = useState({ email: "", password: "" });
  const [form, setForm] = useState();
  const { t } = useTranslation();

  const { i18n } = useTranslation();
  const dir = i18n.dir();

  async function onSubmit({ email, password }) {
    localStorage.removeItem('hesaab/organisationId')
    try {
      await client.post("/auth", {
        email:email.toLowerCase(),
        password,
      });
      await query.refetch({ throwOnError: true });
      history.replace("/");
    } catch (err) {
      if (get(err, "response.status") === 400) {
        let nonFieldErrors = get(err, 'response.data.non_field_errors')

        if (Array.isArray(nonFieldErrors) && nonFieldErrors.length > 0) {
          NotificationManager.error(t(nonFieldErrors[0]))
        } else {
          NotificationManager.error(t("Invalid username or password"))
        }
      } else {
        NotificationManager.error(t("Unable to log in at this time"));
      }
      err.handled = true;
      throw err;
    }
  }
  if (!item) return null;

  return (
    <div className={`
      col-sm
      ${dir== "rtl" ? "rtl" : ""}
    `}>
      <div id="contact-form-1">
        <h3 className="log-title">
          <Trans>Sign in</Trans>
        </h3>
        <p className="log-text" />
        <LocalForm
          initialState={item}
          onSubmit={onSubmit}
          onChange={setItem}
          onUpdate={setForm}
          className="contactForm"
        >
          <FormGroup style={{marginBottom:"1rem"}}>
            <Control.text
              model=".email"
              type="email"
              className="form-control rounded"
              placeholder={t("Email Address")}
              required
            />
          </FormGroup>
          <FormGroup style={{marginBottom:"1rem"}}>
            <Control.text
              model=".password"
              type="password"
              className="form-control rounded"
              placeholder={t("Password")}
              required
            />
          </FormGroup>
          {form && (
            <SaveButton
              type="submit"
              id="form-submit"
              form={form}
              className="btn-primary-filled btn-rounded btn-form-submit btn-rounded mx-0"
            >
              {/* <i className="fa fa-sign-in" aria-hidden="true"></i>  */}
              <Trans>Sign in</Trans>
            </SaveButton>
            
          )}
        </LocalForm>
        <Link className="small" to="/forgotten_password" style={{textDecoration:"none", color:"#72B566"}}>
          <Trans>Forgotten your password?</Trans>
        </Link><br/>
        {/* small form-text text-end */}
        <Link className="small" to="/register" style={{textDecoration:"none", color:"#121127"}} >
          <Trans>Don’t have an account?</Trans> <span style={{color:"#72B566"}}><Trans>Create Account</Trans></span>
        </Link>
      </div>
    </div>
  );
};
